const actions = store => ({
  setLastSimulation: (state, value) => ({lastSimulation: value})
});

export default actions;